<template>
    <el-button v-loading="isloading" type="primary" :size="size" @click="sendbackdee" :disabled="ids.length < 1">
        <i class="fa fa-eyedropper"></i>&nbsp;<slot></slot>
    </el-button>
</template>
<script>
    /**
     * 批量撤回金蝶
     * @author wxq
     * @time 2019-05-22
     */
    export default {
        name: "LyButtonBackdee",
        props: {
            api: String, // 备注提交的地址
            rows: { // 要备注列的数据集合
                type: Array,
                default: () => []
            },            
            size: {
                type: String,
                default: 'small'
            }
        },
        data () {
            return {
                isloading: false
            }
        },
        computed: {
            ids () {
                let id = []
                this.rows.forEach((el) => {
                    if (el.id) {
                        id.push(el.id)
                    }
                })
                return id
            }
        },
        methods: {
            /**
             * 撤回金蝶
             */
            sendbackdee () {
                this.$alert('是否要批量撤回金蝶？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    callback: action => {    
                        this.isloading = true                    
                        this.$api.save(this.api, {
                            ids: this.ids,
                            type: "backjindie"
                        }).then(() => {
                            this.isloading = false
                            this.$message({
                                type: 'success',
                                message: '批量撤回金蝶完成'
                            })
                            this.$emit('sendbackdeeDone')
                        }).catch((msg) => {
                            this.isloading = false
                            this.$message({
                                type: 'warning',
                                message: msg
                            })
                        })
                    }
                })
            }
        }
    }
</script>